import { Skeleton } from '@/components/ui/skeleton';

const PageLoader = () => {
  return (
    <div className="container mx-auto py-8 space-y-4 animate-pulse">
      <Skeleton className="h-12 w-3/4" />
      <Skeleton className="h-64 w-full" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
      <Skeleton className="h-48 w-full" />
    </div>
  );
};

export default PageLoader;
